import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { auth } from '@ink-ai/portal/reducers/auth';

export const NoPermission: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  return (
    <Container maxWidth="sm" sx={{ pt: 8 }}>
      <Box
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          p: 4,
          textAlign: 'center',
          bgcolor: 'background.paper',
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          Access Denied
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Your account does not have the required permissions.<br/>
          Please contact your administrator to request access.
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            // 退出登录以避免在登录页被立即重定向回无权限页
            dispatch(auth.actions.signOut());
            navigate('/login');
          }}
        >
          Back to Login
        </Button>
      </Box>
    </Container>
  );
};

export default NoPermission;
